import { createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const initialState = {};
export const devicesSlice = createSlice({
    name: 'devices',
    initialState,
    reducers: {
        devicesCleared: () => {
            return {};
        },
        deviceUpdated: (state, action) => {
            state[action.payload.id] = action.payload;
        },
        deviceDeleted: (state, action) => {
            delete state[action.payload];
        },
        devicesReplaced: (state, action) => {
            const newState = {};
            for (const device of action.payload) {
                newState[device.id] = device;
            }
            return newState;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (s, action) => {
            const newState = {};
            for (const device of action.payload.devices) {
                newState[device.id] = device;
            }
            return newState;
        });
    }
});
export function selectDevice(state, id) {
    return state.definitions.devices[id];
}
export const { devicesCleared, deviceUpdated, deviceDeleted, devicesReplaced } = devicesSlice.actions;
export const deviceAdded = deviceUpdated;
export default devicesSlice.reducer;
